import React from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddUser } from "./FormAddUser";

export const PanelAddUser = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add user</div>
          </div>
        }
      />
      <PanelBody content={<FormAddUser />} />
    </div>
  );
};
